export const ALIGNMENT = 'alignment';
export const DIGEST = 'digest';
export const TRACE = 'trace';

export type AnalysisType = typeof ALIGNMENT | typeof DIGEST | typeof TRACE;

export interface SequenceAnalysisSummary {
  id: string;
  name: string;
  createdAt: string;
  modifiedAt: string;
  sequenceId: string;
  attachedFileCount: number;
}
